import React from 'react';
import AccountLayout from '../layout/AccountLayout';
import { AccessNotice } from './AccessNotice';

export const AppAccessDenied: React.FC<{ loadFailed?: boolean }> = ({
  loadFailed = false,
}) => (
  <AccountLayout pageTitle="App unavailable">
    <AccessNotice
      title={
        loadFailed
          ? 'We couldn’t load this app'
          : 'You don’t have access to this app'
      }
      description={
        loadFailed
          ? 'We couldn’t check your access right now. Please try again.'
          : 'Your access may have changed, or your invitation may be for a different account.'
      }
      onRetry={loadFailed ? () => window.location.reload() : undefined}
    />
  </AccountLayout>
);
